export default __webpack_public_path__ + "static/media/iconfont.ca414273.ttf";